import { render, staticRenderFns } from "./DevCardKD2.vue?vue&type=template&id=7c19913c&scoped=true"
import script from "./DevCardKD2.vue?vue&type=script&lang=js"
export * from "./DevCardKD2.vue?vue&type=script&lang=js"
import style0 from "./DevCardKD2.vue?vue&type=style&index=0&id=7c19913c&prod&lang=css"
import style1 from "./DevCardKD2.vue?vue&type=style&index=1&id=7c19913c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c19913c",
  null
  
)

export default component.exports